(function () {
        const bars = document.querySelectorAll('.annoucement-bar-d5');
        bars.forEach((bar) => {
          bar.querySelector('.ans-close-icon-d5').addEventListener('click', () => {
            bar.style.display = 'none';
          });
        });
      })();
      (function () {
        const buttons = document.querySelectorAll('.open-quick-modal-d5');
        const quickModal = document.querySelector('.quick-modal-d5');
        const quickContent = quickModal.querySelector('.quick-content-d5');
        const closeBtn = document.querySelectorAll('[quick-close]');
        buttons.forEach((btn) => {
          btn.addEventListener('click', () => {
            const apiD5 = btn.getAttribute('data-url');
            quickModal.classList.add('active');
            fetch(apiD5)
              .then((response) => response.text())
              .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const d5MainProduct = doc.querySelector('.d5-main-product');

                if (d5MainProduct) {
                  quickContent.innerHTML = '';
                  quickContent.appendChild(d5MainProduct);
                  setTimeout(() => {
                    initATCOverlay();
                    window.reattachFormListeners();
                  }, 300);
                } else {
                  quickModal.classList.remove('active');
                  quickContent.innerHTML = '';
                }
              })
              .catch((error) => {
                console.error('Error:', error);
              });
          });
        });
        closeBtn.forEach((b) => {
          b.addEventListener('click', () => {
            quickModal.classList.remove('active');
            quickContent.innerHTML = '';
          });
        });
      })();
      function initATCOverlay() {
        const button = document.querySelector('.atc-overlay-d5.active');
        const buttonOver = document.querySelector('.atc-overlay-d5');
        const warn = document.querySelector('.disable-warn-atc-d5');
        if (!button || !buttonOver || !warn) return;

        button.addEventListener('click', () => {
          warn.classList.add('active');
          setTimeout(() => {
            warn.classList.remove('active');
          }, 3000);
        });

        const selectElement = document.querySelector('.variant-select-tag-d5');

        if (!selectElement) return;
        selectElement.addEventListener('change', () => {
          const submitBtn = document.querySelector('.product-form__submit');
          const input = document.querySelector('.product-variant-id');
          const selectedOption = selectElement.options[selectElement.selectedIndex];

          if (selectedOption.value === '-1') {
            buttonOver.classList.add('active');
            submitBtn.querySelector('span').textContent = 'Pick your model'
            submitBtn.setAttribute('disabled', '');
            return;
          }

          buttonOver.classList.remove('active');
          warn.classList.remove('active');

          input.value = selectedOption.value;
          input.dataset.variantTitle = selectedOption.textContent;
            submitBtn.querySelector('span').textContent = 'Add to cart'
          submitBtn.removeAttribute('disabled');
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selectedOption.value);
          history.replaceState(null, '', url);

          let mediaId = selectedOption.getAttribute('variant-img');
          const thumbs = document.querySelectorAll('.thumbnail-list__item .thumbnail[aria-current="true"] img');
const mainImgs = document.querySelectorAll('.product__media-item.is-active img');

if (mediaId) {

  // Update all main images
  mainImgs.forEach((img) => {
    img.srcset = '';
    img.src = mediaId;
  });

  // Create thumbnail version (width=200)
  const thumbUrl = mediaId.replace(/width=\d+/, "width=200");

  // Update all thumbnails
  thumbs.forEach((img) => {
    img.srcset = '';
    img.src = thumbUrl;
  });
}


          if (selectedOption.hasAttribute('sold')) {
            submitBtn.setAttribute('disabled', 'disabled');
            submitBtn.querySelector('span').textContent = 'Soldout'
          }
        });
      }

      document.addEventListener('DOMContentLoaded', initATCOverlay);